import { Overlay } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { ReactComponent as SaveTripIllustration } from '@eti/assets/illustrations/default/saved-trip.svg';
import { Heading, Inline, Stack } from '@etg/wings';
import { usePrevious } from '@eti/utils';
import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import type { TripDataType } from '../../../../common/custom-hooks/save-trips/models';
import { SavedTripCard } from './drawer/saveTrip/SavedTripCard';

const informationWrapper = css`
  padding: 16px;
`;

export interface SaveTripDrawerProps {
  closeSavedTripDrawer: () => void;
  isSavedTripDrawerOpen: boolean;
  removeSavedTrip: (tripKey: string) => void;
  savedTrips: TripDataType[];
  setIsItineraryDrawerSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

const SaveTripDrawer = ({
  closeSavedTripDrawer,
  isSavedTripDrawerOpen,
  removeSavedTrip,
  savedTrips,
  setIsItineraryDrawerSelfTransferModalOpen,
}: SaveTripDrawerProps) => {
  const { t } = useTranslation();
  const [shouldAnnounceRemovedTrip, setShouldAnnounceRemovedTrip] = useState(false);
  const prevSavedTripsLength = usePrevious(savedTrips?.length);

  useEffect(() => {
    if (prevSavedTripsLength && prevSavedTripsLength > savedTrips?.length) {
      setShouldAnnounceRemovedTrip(true);

      setTimeout(() => {
        setShouldAnnounceRemovedTrip(false);
      }, 1000);
    }
  }, [prevSavedTripsLength, savedTrips.length]);

  return (
    <Overlay.Drawer
      dataTestId="save-trip-button-drawer"
      handleClose={closeSavedTripDrawer}
      isOpen={isSavedTripDrawerOpen}
    >
      <Overlay.Header
        onClose={closeSavedTripDrawer}
        shouldFocusDrawerHeader={shouldAnnounceRemovedTrip}
        title={t('Result.SaveTrip.Header.Text')}
      />
      <Overlay.Content>
        {savedTrips.length === 0 && (
          <Stack className={informationWrapper} spacing={16}>
            <Heading level={3}>{t('Result.NoSavedTrips.Title.Text')}</Heading>
            <p>{t('Result.NoSavedTrips.Information.Text')}</p>
            <Inline align="center">
              <SaveTripIllustration />
            </Inline>
          </Stack>
        )}
        {savedTrips.map((trip) => (
          <SavedTripCard
            key={trip.selectionKey}
            removeSavedTrip={removeSavedTrip}
            setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
            trip={trip}
          />
        ))}
      </Overlay.Content>
    </Overlay.Drawer>
  );
};
export default SaveTripDrawer;
